import { render, staticRenderFns } from "./Header_Name.vue?vue&type=template&id=158b397b&"
import script from "./Header_Name.vue?vue&type=script&lang=js&"
export * from "./Header_Name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports